<template>
  <div class="service-request-page-step__wrapper service-request-page-step-table">
    <div class="service-request-page__steps">
      <div class="service-request-page__step">
        <div class="service-request-page__col-left">
          <div class="service-request-page__col">
            <div class="service-request-page__col-name">{{ getMain.form.dealer_id.label }}</div>
            <div class="service-request-page__col-val">{{ infoDealer.text }}</div>
          </div>
          <div class="service-request-page__col">
            <div class="service-request-page__col-name">{{ getMain.tabs.tab2.labels.address }}</div>
            <div class="service-request-page__col-val">{{ infoDealer.address }} - {{ infoDealer.city }}</div>
          </div>
        </div>
        <BaseButton
          v-if="$route.query.dealer"
          class="service-request-page__col-right"
          type="primary"
          style="opacity: 0;visibility: hidden"
        >
          {{ getMain.changeButtonText }}
          <IconArrow class="icon-right" />
        </BaseButton>
        <BaseButton
          v-if="!$route.query.dealer"
          class="service-request-page__col-right"
          type="primary"
          @click="changeStepTab($route.query.dealer == null ? 0 : 1)"
        >
          {{ getMain.changeButtonText }}
          <IconArrow class="icon-right" />
        </BaseButton>
      </div>
      <div class="service-request-page__step">
        <div class="service-request-page__col-left">
          <div class="service-request-page__col">
            <div class="service-request-page__col-name">{{ getMain.form.service_id.label }}</div>
            <div class="service-request-page__col-val">{{ serviceLabel }}</div>
          </div>
          <div v-if="subServiceLabel" class="service-request-page__col">
            <div class="service-request-page__col-name">{{ getMain.form.sub_service_id.label }} </div>
            <div class="service-request-page__col-val">{{ subServiceLabel }}</div>
          </div>
          <div class="service-request-page__col">
            <div class="service-request-page__col-name">{{ getMain.form.date_time.label }}</div>
            <div class="service-request-page__col-val">{{ form.date_time ? formatDate(form.date_time) : null }}</div>
          </div>
          <div class="service-request-page__col">
            <div class="service-request-page__col-name">{{ getMain.form.mobility_id.label }} </div>
            <div class="service-request-page__col-val">{{ mobilityLabel }}</div>
          </div>
        </div>
        <BaseButton
          class="service-request-page__col-right"
          type="primary"
          @click="changeStepTab(1)"
        >
          {{ getMain.changeButtonText }}
          <IconArrow class="icon-right" />
        </BaseButton>
      </div>
      <div v-if="form.state_number || form.vin_number" class="service-request-page__step">
        <div class="service-request-page__col-left">
          <div v-if="form.state_number" class="service-request-page__col">
            <div class="service-request-page__col-name">{{ getMain.form.state_number.label }}</div>
            <div class="service-request-page__col-val">{{ form.state_number }}</div>
          </div>
          <div v-if="form.vin_number" class="service-request-page__col">
            <div class="service-request-page__col-name">{{ getMain.form.vin_number.label }}</div>
            <div class="service-request-page__col-val">{{ form.vin_number }}</div>
          </div>
        </div>
        <BaseButton
          class="service-request-page__col-right"
          type="primary"
          @click="changeStepTab(2)"
        >
          {{ getMain.changeButtonText }}
          <IconArrow class="icon-right" />
        </BaseButton>
      </div>
      <div v-if="form.engine || form.model || form.year " class="service-request-page__step">
        <div class="service-request-page__col-left">
          <div class="service-request-page__col">
            <div class="service-request-page__col-name">{{ getMain.form.model.label }}</div>
            <div class="service-request-page__col-val">{{ form.model }}</div>
          </div>
          <div class="service-request-page__col">
            <div class="service-request-page__col-name">{{ getMain.form.year.label }}</div>
            <div class="service-request-page__col-val">{{ form.year }}</div>
          </div>
          <div class="service-request-page__col">
            <div class="service-request-page__col-name">{{ getMain.form.engine.label }}</div>
            <div class="service-request-page__col-val">{{ form.engine }}</div>
          </div>
        </div>
        <BaseButton
          class="service-request-page__col-right"
          type="primary"
          @click="changeStepTab(2)"
        >
          {{ getMain.changeButtonText }}
          <IconArrow class="icon-right" />
        </BaseButton>
      </div>
      <div class="service-request-page__step">
        <div class="service-request-page__col-left">
          <div class="service-request-page__col">
            <div class="service-request-page__col-name">{{ getMain.form.last_name.label }}</div>
            <div class="service-request-page__col-val">{{ form.last_name }}</div>
          </div>
          <div class="service-request-page__col">
            <div class="service-request-page__col-name">{{ getMain.form.first_name.label }}</div>
            <div class="service-request-page__col-val">{{ form.first_name }}</div>
          </div>
          <div class="service-request-page__col">
            <div class="service-request-page__col-name">{{ getMain.form.phone.label }}</div>
            <div class="service-request-page__col-val">{{ form.phone }}</div>
          </div>
          <div class="service-request-page__col">
            <div class="service-request-page__col-name">
              {{ getMain.form.contact_method.label }}
            </div>
            <div class="service-request-page__col-val">
              <IconPhone v-if="form.contact_method === 1" />
              <IconWhatsapp v-if="form.contact_method === 5" />
              <IconTelegram v-if="form.contact_method === 4" />
              <IconViber v-if="form.contact_method === 3" />
              <IconFb v-if="form.contact_method === 6" />
              {{ contactMethodLabel }}
            </div>
          </div>
        </div>
        <BaseButton
          class="service-request-page__col-right"
          type="primary"
          @click="changeStepTab(3)"
        >
          {{ getMain.changeButtonText }}
          <IconArrow class="icon-right" />
        </BaseButton>
      </div>
      <div v-if="getMain.hintText" class="service-request-page__editor-wrapper">
        <p class="service-request-page__editor" v-html="getMain.hintText" />
      </div>
    </div>

    <BaseCheckbox
      v-model="form.policy"
      :errorMsg="errorMsgs.policy"
    >
      {{ getMain.policyLabel }}
      <router-link to="/policy">
        {{ getMain.policyLinkLabel }}
      </router-link>
    </BaseCheckbox>
    <BaseCheckbox
      v-model="form.marketing"
      :errorMsg="errorMsgs.policy"
    >
      {{ getMain.marketingConsentLabel }}
      <router-link to="/marketing-consent">
        {{ getMain.marketingConsentLinkLabel }}
      </router-link>
    </BaseCheckbox>

    <BaseButton
      class="service-request-page__button"
      type="primary"
      :disabled="!form.policy"
      @click="submitForm"
    >
      {{ getMain.submitButtonText }}
      <IconArrow class="icon-right" />
    </BaseButton>
  </div>
</template>

<script>
  import { mapGetters, mapActions, mapState } from 'vuex'
  import IconArrow from '@/assets/img/icons/arrow-long-right.svg?inline'
  import IconWhatsapp from '@/assets/img/icons/whatsapp.svg?inline'
  import IconTelegram from '@/assets/img/icons/telegram.svg?inline'
  import IconViber from '@/assets/img/icons/viber.svg?inline'
  import IconFb from '@/assets/img/icons/facebook.svg?inline'
  import IconPhone from '@/assets/img/icons/phone.svg?inline'
  import { isMd } from '@/config'

  export default {
    name: 'Step5',
    components: {
      IconArrow,
      IconWhatsapp,
      IconTelegram,
      IconViber,
      IconFb,
      IconPhone
    },
    props: {
      form: [Object, String],
      submitForm: Function,
      changeStepTab: Function,
      errorMsgs: Object,
      infoDealer: Object,
      moboiltiesItems: Array,
      dealerServices: Array,
      dealer: Object
    },

    computed: {
      ...mapGetters(['getMain', 'isShow', 'getPhoneType']),
      ...mapState(['currentLang']),
      serviceLabel () {
        const service = this.getMain.form.service_id.items.find(
          s => s.value === this.form.service_id
        )
        return service ? service.label : '-'
      },
      subServiceLabel () {
        const lang = this.currentLang || 'ru'

        const service = this.dealerServices.find(
          el => el.id === this.form.service_id
        )

        if (!service || !service.subServices) return '-'

        const subService = service.subServices.find(
          s => Number(s.id) === Number(this.form.sub_service_id)
        )

        return subService ? subService[`label_${lang}`] : ''
      },

      cityLabel () {
        const city = this.getMain.form.city_id.items.find(
          c => c.value === this.form.city_id
        )
        return city ? city.text : '-'
      },

      contactMethodLabel () {
        const method = this.getMain.form.contact_method.items.find(
          c => c.value === this.form.contact_method
        )
        return method ? method.text : '-'
      },

      mobilityLabel () {
        const mobility = this.moboiltiesItems.find(
          s => s.value === this.form.mobility_id
        )
        return mobility ? mobility.text : '-'
      }
    },

    methods: {
      ...mapActions(['submitServiceRequest']),
      formatDate (timestamp) {
        if (!timestamp) return '-'

        const date = new Date(Number(timestamp))

        const options = {
          day: 'numeric',
          month: 'long',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
          timeZone: 'Europe/Kiev'
        }

        const locale = (() => {
          if (isMd || this.currentLang === 'ro') return 'ro-MD'
          if (this.currentLang === 'ru') return 'ru-RU'
          return 'uk-UA'
        })()

        return date.toLocaleString(locale, options)
      }
    }
  }
</script>

<style lang="scss">
  .service-request-page-step-table{
    margin-top: -36px;
    @media (max-width: 1024px) {
      margin-top: -16px;
    }
    @media (max-width: 767px) {
      margin-top: 0;
    }

    .service-request-page__button{
      margin-top: 40px;
      @media (max-width: 767px) {
        margin-top: 16px;
        margin-bottom: 16px;
      }
    }

    .service-request-page__editor-wrapper{
      @media (max-width: 767px) {
        padding-top: 0;

      }
    }

    .checkbox-wrapper{
      width: max-content;
    }
  }
  .service-request-page__steps{
    display: flex;
    flex-direction: column;

  }
  .service-request-page__step{
    border-top: 1px solid  $c-gray-light;
    padding: 24px 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media (max-width: 767px) {
      flex-direction: column;
      align-items: flex-start;
      padding: 16px 0;
      gap: 16px;
    }
  }

  .service-request-page__col{
    width: 100%;
    &-left{
      width: 100%;
      display: grid;
      grid-template-columns: repeat(4,1fr);
      gap: 24px;
      @media (max-width: 1200px){
       grid-template-columns: repeat(1,1fr);
        gap: 8px;
      }
    }
    &-right{
      &.button{
        font-family: 'NobelWGL-Bold';
        font-size: 14px;
        line-height: 20px;
        font-weight: 700;
        display: flex;
        letter-spacing: 1px;
        text-transform: uppercase;
        gap: 8px;
        background: transparent!important;
        color: $c-azure!important;
        padding: 8px 0 8px 0px;
        svg path{
          fill: $c-azure;
        }
      }

    }

    &-name{
      font-family: 'NobelWGL-Book';
      font-weight: 400;
      font-size: 10px;
      line-height: 14px;
      letter-spacing: 0.1px;
      color: $c-gray-new;
    }

    &-val{
      display: flex;
      align-items: center;
      gap: 8px;
      font-family: 'NobelWGL-Book';
      font-weight: 400;
      font-size: 18px;
      line-height: 30px;
      letter-spacing: 1px;
      svg{
        display: block;
        width: 20px;
        height: 20px;
      }
    }
  }

</style>
